import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid2,
  IconButton,
  Stack,
  Switch,
} from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialInput from "../../../components/MaterialInput";
import MaterialBox from "../../../components/MaterialBox";
import { useCountryFormState } from "./components/CountryStateHandle";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import MaterialButton from "../../../components/MaterialButton";
import DashboardFooter from "../../../layoutcontainers/DashboardLayout/components/Footer";
import { fetchDataById, postData, putData } from "../../../services";
import { useEffect } from "react";
import { useSnackbar } from "../../../context/popup";

const CountryForm = () => {

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { showSnackbar } = useSnackbar();
  const countryId = searchParams.get("id");
  const pageType = searchParams.get("pageType");

  const { formData, setFormData, handleChange, checkAllFields } =
    useCountryFormState();
  const pageMode = pageType === "view" ? "view" : pageType === "edit" ? "edit" : "add";


  useEffect(() => {
    if (pageMode === "add" || !countryId) {
      return;
    }
    const fetchCountryById = async (countryId) => {
      try {
        const data = await fetchDataById(`/reference/general/country/${countryId}`);
        const responseData = data?.data;
        if (data?.success) {
          setFormData((prev) => ({
            ...prev,
            name: responseData.name || "",
            code: responseData.code || "",
            active: responseData.isActive,
            iplCountryId: responseData.id || "",
            // reset status fields
            nameStatus: responseData.name ? "success" : "unchecked",
            codeStatus: responseData.code ? "success" : "unchecked",
            iplCountryIdStatus: responseData.id ? "success" : "unchecked",
          }));
        } else {
          //throw error message
        }
      } catch (error) {
        console.error("Error fetching data by ID:", error);
        showSnackbar(error?.response?.data?.message || "Error fetching data by ID" , "error");
      }
    };
    fetchCountryById(countryId);
  }, [pageMode]);

  //POST and PUT Action Function
  const handleCountryAction = async () => {
    const payload = {
      name: formData?.name,
      code: formData?.code,
      isActive: formData?.active,
    };
    //Update
    if (countryId) {
      try {
        const response = await putData(
          `/reference/general/country/${countryId}`,
          payload
        );
        const responseMessage = response?.message;
        if (response?.success) {
          //success message
          showSnackbar(responseMessage, "success");
          navigate("/general-master/country-list");
        } else {
          //error message
          showSnackbar(responseMessage, "error");
        }
      } catch (error) {
        console.error("Error updating data:", error);
        showSnackbar(error?.response?.data?.message, "error");
      }
    } else {
      //Submit
      try {
        const response = await postData("/reference/general/country", payload);
        const responseMessage = response?.message;
        if (response?.success) {
          //success message
          showSnackbar(responseMessage, "success");
          navigate("/general-master/country-list");
        } else {
          //error message
          showSnackbar(responseMessage, "error");
        }
      } catch (error) {
        console.error("Error posting data:", error);
        //catch error message
        showSnackbar(error?.response?.data?.message, "error");
      }
    }
  };

  return (
    <>
      <DashboardLayout>
        <Card sx={{ minHeight: 400 }}>
          <CardHeader
            title={
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <IconButton
                    onClick={() => navigate("/general-master/country-list")}
                  >
                    <ArrowBack />
                  </IconButton>
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Country Details
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                      Enter New Country Details from around the world.
                    </MaterialTypography>
                  </Stack>
                </Stack>
              </Stack>
            }
          />

          <CardContent>
            <Grid2 container spacing={2}>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Country Name*
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="name"
                  placeholder="eg. India"
                  value={formData.name}
                  onChange={handleChange}
                  error={formData.nameStatus === "error"}
                  success={formData.nameStatus === "success"}
                  disabled={pageMode === "view"}
                />
                {formData.nameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Country Name should be a minimum 1 character & maximum 60
                      characters long.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Country Code*
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="code"
                  placeholder= "eg. IND"
                  value={formData.code}
                  onChange={handleChange}
                  error={formData.codeStatus === "error"}
                  success={formData.codeStatus === "success"}
                  disabled={pageMode === "view"}
                />
              </Grid2>
              {(pageMode === "edit" || pageMode === "view") && (
                <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                  <MaterialBox>
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Country ID
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    name="iplCountryId"
                    value={formData.iplCountryId}
                    onChange={handleChange}
                    error={formData.iplCountryIdStatus === "error"}
                    success={formData.iplCountryIdStatus === "success"}
                    disabled
                  />
                </Grid2>
              )}
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Active
                  </MaterialTypography>
                </MaterialBox>
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.active}
                      onChange={(e) =>
                        handleChange({
                          target: {
                            name: "active",
                            value: e.target.checked,
                          },
                        })
                      }
                      disabled={pageMode === "view"}
                      color="primary"
                    />
                  }
                  label={
                    <MaterialTypography variant="caption" fontWeight="bold">
                      {formData?.active ? "Yes" : "No"}
                    </MaterialTypography>
                  }
                  sx={{ marginLeft: 0 }}
                />
              </Grid2>
            </Grid2>
          </CardContent>
          <MaterialBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            {pageMode === "add" && (
              <>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="outlined"
                  color="dark"
                  onClick={() => navigate("/general-master/country-list")}
                >
                  Cancel
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={!checkAllFields()}
                  onClick={handleCountryAction}
                >
                  Submit
                </MaterialButton>
              </>
            )}

            {pageMode === "edit" && (
              <>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="outlined"
                  color="dark"
                  onClick={() => navigate("/general-master/country-list")}
                >
                  Cancel
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={!checkAllFields()}
                  onClick={handleCountryAction}
                >
                  Update
                </MaterialButton>
              </>
            )}
          </MaterialBox>
        </Card>
      </DashboardLayout>
      <DashboardFooter />
    </>
  );
};

export default CountryForm;
